module.exports = __webpack_public_path__ + "b99c32e84b8a0107e9000576c31868dd.svg";